import React from "react";
import { get } from "lodash";

export const tableTextFilterMethod = (filter, row) => {
  const { id, value } = filter;
  const text = row[id].toString().toUpperCase();
  const search = value.toUpperCase();
  return text.includes(search);
};

export const formatCPF = (d) => {
  const cpf = get(d, "original.cpf", "");

  if (cpf) {
    const formated_cpf = cpf.replace(/(-)|(\.)/g, "");
    return (
      <em>
        {formated_cpf.substring(0, 3)}.{formated_cpf.substring(3, 6)}.
        {formated_cpf.substring(6, 9)}-{formated_cpf.substring(9, 11)}
      </em>
    );
  }
  return null;
};

export const formatCurrency = (value) =>
  value.toLocaleString("pt-BR", { style: "currency", currency: "BRL" });
export const convertCurrencyValue = (value) =>
  +value
    .replace("R$", "")
    .replace(".", "")
    .replace(",", ".");
export default tableTextFilterMethod;

export const verifyRequiredValue = (val) => {
  let invalid = [null, undefined, ""];
  if (invalid.includes(val)) {
    return false;
  }
  if (
    (typeof val == "string" && val.length === 0) ||
    (typeof val == "string" && val.trim().length === 0)
  ) {
    return false;
  }

  return true;
};

export const batchVerifyRequiredValues = (data, fields) => {
  const invalid = new Set([null, undefined, ""]);

  for (const field of fields) {
    const value = data[field];
    if (
      !(field in data) ||
      invalid.has(value) ||
      (typeof value === "string" && value.trim() === "")
    ) {
      return { valid: false, field };
    }
  }

  return { valid: true };
};

export const checkAge = (date) => {
  const [day, month, year] = date.split("/").map(Number);
  const validDate = new Date(year, month - 1, day);

  if (!isNaN(validDate.getTime())) {
    const today = new Date();
    let age = today.getFullYear() - validDate.getFullYear();

    const hasNotHadBirthdayThisYear =
      today.getMonth() < validDate.getMonth() ||
      (today.getMonth() === validDate.getMonth() &&
      today.getDate() < validDate.getDate());

    if (hasNotHadBirthdayThisYear) {
      age--;
    }
    return age;
  }
}

// `btoa`/`atob` trabalham byte a byte (Latin-1) e quebram com acentos, por isso
// convertemos a string para UTF-8 antes de codificar e de volta ao decodificar.
export const encodeBase64 = (text) => {
  let binary = "";
  new TextEncoder().encode(text).forEach((byte) => {
    binary += String.fromCharCode(byte);
  });
  return btoa(binary);
};

export const decodeBase64 = (encoded) => {
  let bytes;

  try {
    bytes = Uint8Array.from(atob(encoded || ""), (char) => char.charCodeAt(0));
  } catch (e) {
    return "";
  }

  try {
    return new TextDecoder("utf-8", { fatal: true }).decode(bytes);
  } catch (e) {
    // Relatórios salvos antes desta correção foram codificados byte a byte
    // pelo `btoa`, então não são UTF-8 válido.
    return new TextDecoder("iso-8859-1").decode(bytes);
  }
};

export const capitalize = (string) =>
  string
    .split(" ")
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
    .join(" ");
